import { Injectable } from '@angular/core';
import { Sat } from '../../types/sat/sat.type';
import { BaseMapper } from '../shared/base.mapper';
import * as _ from 'lodash';
import { PagedApiResponse } from '../../types/shared/_paged-api-response.type';

@Injectable()
export class SatMapper extends BaseMapper<Sat> {

    mapPagedApiResponse<T>(data: any, mapper: (data: any, objectType?: any) => Array<T>, objectType?: any): PagedApiResponse<T> {
        const response = new PagedApiResponse<T>();
        response.count = data.count;
        response.rows = mapper(data.rows, objectType);

        return response;
    }

    }

